import { fileApiWithHeader } from "./api";
import { API_STATUS } from "./constant";
import { BACKEND_API_BASE_URL } from "../utilities/constant";
import { getUserAccessToken } from "../utilities/setting";
import axios from "axios";
import { checkAuthSession } from "../views/dashboard/auth/auth-utils";

export const uploadApiCall = async (url, params) => {

    await checkAuthSession();
    const token = getUserAccessToken();

    // Call API without manually specifying Content-Type
    // const response = await fileApiWithHeader(BACKEND_API_BASE_URL, token)
    //     .post(url, params)
    //     .catch((error) => {
    //         let errorMsg;
    //         if (error.response === undefined) {
    //             errorMsg = 'A network error occurred. This could be a CORS issue or a dropped internet connection.';
    //         } else {
    //             const dataMsg = error.response.data.message
    //                 ? String(error.response.data.message)
    //                 : '';
    //             const explanationMsg = error.response.data.error.explanation
    //                 ? String(error.response.data.error.explanation)
    //                 : '';
    //             errorMsg = `${dataMsg} ${explanationMsg}`;
    //         }
    //         return Promise.reject(errorMsg);
    //     });

    const response = await fetch(`${BACKEND_API_BASE_URL}/v2/saveFile`,params, {
        method:"post",
        headers:{
            Authorization:token,
            "Content-Type":"application/json"
        }
    }).then((data)=>{
        console.log("DTA HERE", data);
    })


    if (response.status === API_STATUS.SUCCESS  || response.status === API_STATUS.CREATED) {
        return response.data.data;
    } else {
        return Promise.reject(response.data);
    }
};


// export const postApiMediaCall = async (url, formData) => {
  
//     return apiWithHeader(BACKEND_API_BASE_URL, 'multipart/form-data')
//     .post(url, formData)
//     .catch(function (error) {
//       return error.response;
//     });

// };

// export const postApiMediaCall = async (url, formData) => {
//   const token = getUserAccessToken();
  
//   const response = await apiWithHeader(BACKEND_API_BASE_URL, 'multipart/form-data', token)
//   .post(url, formData)
//   .catch(function (error) {
//       if(error.response == undefined){
//           var errorMsg = 'A network error occurred. This could be a CORS issue or a dropped internet connection.';
//       }else{
//           const dataMsg = error.response.data.message ? String(error.response.data.message) : '';
//           const explanationMsg = error.response.data.error.explanation ? String(error.response.data.error.explanation) : '';
//           var errorMsg = `${dataMsg} ${explanationMsg}`
//       }
//       return Promise.reject(errorMsg);
//   });

//   if (response.status === API_STATUS.SUCCESS || response.status === API_STATUS.ACCEPTED || response.status === API_STATUS.CREATED) {
//       return response.data.data;
//   } else {
//       return Promise.reject(response.data);
//   }
// };
